/*! @azure/msal-common v9.0.1 2022-12-07 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "9.0.1";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
